import React from 'react';
import { connect } from 'react-redux';
import { withLayout } from '../../common/layout';

import { PROP_KEYS } from '../home/home-constants';
import { homeActions } from '../home/home-reducer';

class Solutions extends React.Component {
    
    componentDidMount() {
        document.getElementById("initialTripAdvisorWidget").className = "tripAdvisorWidget-content";
        this.props.getSolutionsPageHtml();
    }
    
    componentWillUpdate() {
        document.getElementById("initialTripAdvisorWidget").className = "tripAdvisorWidget-content";
    }
    
    componentWillUnmount() {
        document.getElementById("initialTripAdvisorWidget").className = "display-none";
    }

    render() {
        const html = {__html: this.props.solutionsPage};

        return (
            <div dangerouslySetInnerHTML={html}></div>
        );
    }
}

function mapStateToProps(state) {
    const { authentication, location: { solutionsPage } } = state;
    const { user } = authentication;
    return {
        user,
        solutionsPage
    };
}

const mapDispatchToProps = {
    getSolutionsPageHtml: () => homeActions.loadHtml(PROP_KEYS.solutionsPage)
}

const connectedSolutions = connect(mapStateToProps, mapDispatchToProps)(withLayout(Solutions));
export { connectedSolutions as Solutions };
